import { timestamp } from "../../../app/data/validate";

function XeroInvoiceApi({ firebase }) {
    const create = firebase.functions().httpsCallable('createInvoice');    
    
    this.buildMemberInvoice = ({
        vatNumber,
        xeroContactId,
        date,
        dueDate,
        url,
        bookingReference,
        status,
        items,
        tariff,
        accountCode = "310"
    }) => {
        // const TaxType = vatNumber ? 'INPUT2' : 'NONE';

        return {
            Type: "ACCPAY",
            Contact: {
                ContactID: xeroContactId
            },
            Date: date.format('YYYY-MM-DD'),
            DueDate: dueDate.format('YYYY-MM-DD'),
            Url: url,
            Reference: bookingReference,
            InvoiceNumber: bookingReference,
            Status: status,
            LineItems: items.filter(({ amount }) => amount > 0).map(item => {

                const rate = item.category === 'services' ? tariff.services[item.section][item.code].rate : item.rate;

                return {
                    Description: item.description,
                    Quantity: item.quantity,
                    UnitAmount: rate,
                    AccountCode: accountCode,
                    TaxType: 'NONE'
                }
            })
        };
    }

    this.buildSalesInvoice = ({
        xeroContactId,
        date,
        dueDate,
        url,
        bookingReference,
        status = "SUBMITTED",
        items,
        tariff,
        accountCode = "200"
    }) => {
        return {
            Type: "ACCREC",
            Contact: {
                ContactID: xeroContactId
            },
            Date: date.format('YYYY-MM-DD'),
            DueDate: dueDate.format('YYYY-MM-DD'),
            Url: url,
            Reference: bookingReference,
            Status: status,
            LineItems: items.filter(({ amount }) => amount > 0).map(item => {
                const product = tariff[item.category][item.section][item.code];
                const rate = item.category === 'services' ? product.chargeRate ?? product.rate : item.rate;
                
                return {
                    Description: item.description,
                    Quantity: item.quantity,
                    UnitAmount: rate,
                    AccountCode: accountCode
                }
            })
        };
    }

    this.createInvoice = invoice => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await create({ Invoices: [{ ...invoice }] });
                const result = response.data.Invoices[0];

                resolve ({ 
                    ...invoice, 
                    xeroInvoiceId: result.InvoiceID ?? '!?', 
                    // XERO doesn't generate an invoice number for bills / purchase invoices / ACCPAY
                    reference: result.InvoiceNumber || invoice.reference,
                    ts: timestamp()
                })
               
            }
            catch (error) {
                reject(error);
            }
        })
    }
}




export default XeroInvoiceApi;